import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBSignUpIcon from './SBSignUpIcon.vue';

@Component({
    components: {
        SBSignUpIcon,
    }
})
export default class SBSignUpForm extends Mixins(SBComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public title!: string;

    @Prop({
        type: String,
        default: "",
    })
    public enTitle!: string;

    @Prop({
        type: Boolean,
        default: false,
    })
    public required!: boolean;

    @Prop({
        type: String,
        default: "",
    })
    public error!: string;

}
